<template>

<modal title="Segui Nuovo" v-model="searchMicrochipModal">

<Vueform ref="searchMicrochipForm$">
        <TextElement name="microchip" label="Microchip" rules="required" />
        <button type="button" id="close" class="btn btn-secondary" @click="searchMicrochipModal = 0">Chiudi</button>
        &nbsp;<button type="button" class="btn btn-primary" :class="{loading: loading}" @click="searchMicrochip">Cerca</button>
</Vueform>

</modal>

<modal title="Richiesta di follow" v-model="importModal">

<div style="text-align: center;">
    <soft-avatar
          :img="getImage(importHorse?.horse_images)"
          size="xxl"
          border-radius="sm"
          class="m-3"
          alt="profile_image"
      />
      <h3>{{ importHorse?.name }}</h3>
      <h4>{{ getUserName(user) }}</h4>
      <h4>{{ user?.email }}</h4>
      <hr/>
      <button type="button" id="close" class="btn btn-secondary" @click="importModal = 0">Chiudi</button>
      &nbsp;<button type="button" class="btn btn-success" :class="{loading: loading}" @click="followRequest">Invia richiesta di follow</button>
</div>

</modal>
</template>

<script>

import Modal from "@/components/Modal";
import {horseImagesService} from "@/services/HorseImagesService";
import SoftAvatar from "@/components/SoftAvatar.vue";
import {horsesService} from "@/services/HorsesService";

export default {
  name: "follow-horse",
  emits: ['update:show'],
  props: {
    show: {
      type: Boolean,
      required: true
    },
  },
  components: {
    Modal, 
    SoftAvatar
  },
  data() {
    return {
      importModal: 0,
      confirmModal: 0,
      importHorse: null,
      searchMicrochipModal: this.show,
      user: null,
      loading: 0,
    };
  },
  watch: {
    show(newValue) {
      this.searchMicrochipModal = newValue;
    },
    searchMicrochipModal(newValue){
      if(!newValue) this.$emit('update:show', 0);
    }
  },
  created() {
  },
  methods: {
    async searchMicrochip(){
        const form = this.$refs.searchMicrochipForm$;
        form.validate();
        if (form.hasErrors) return;
        this.loading=true;
          try{
            this.importHorse = await horsesService.findMicrochip(form.data.microchip);
            if(!this.importHorse) throw new Error("Microchip not found");
            this.importModal = 1;
            this.searchMicrochipModal = 0;
            this.user = this.importHorse?.owned_horses[0]?.user;
          }finally{
            this.loading=false;
          }
    },
    async followRequest(){
        this.loading=true;
          try{
            this.importHorse = await horsesService.followRequest(this.importHorse.id);
            if(!this.importHorse) throw new Error("Failed.");
            this.importModal = 0;
            this.$emit('done');
          }finally{
            this.loading=false;
          }
    },
    getImage(horseImages) {
      return horseImagesService.getImage(horseImages);
    },
    getUserName(user){
      return (user?.first_name || user?.last_name ? (user?.first_name + ' ' + user?.last_name) : 'UNKNOWN' )+ ' (' + user?.username + ')'
    }
  }
};
</script>
